import onReceivedSuggestionsToRender from '../actions/onReceivedSuggestionsToRender';
import getScenarioStore from '../store/getScenarioStore';
import { mutator } from 'satcheljs';

mutator(onReceivedSuggestionsToRender, actionMessage => {
    getScenarioStore(actionMessage.scenarioId).displayedQFRequestTime =
        actionMessage.displayedQFRequestTime;
});
